<template>
  <div>
    <h1 class="sctl-title">特定商取引法に基づく表記</h1>
    <table class="sctl-table">
      <tbody>
        <tr class="sctl-table-row" v-for="sctl in sctlItems" :key="sctl.item">
          <td>
            <div class="sctl-table-headline">{{ sctl.item }}</div>
          </td>
          <td class="sctl-table-content">{{ sctl.content }}</td>
        </tr>
      </tbody>
    </table>
  </div> 
</template>

<script>

export default {
  name: 'app',
  components: {
    // なし
  },
  data: function(){
      return {
        sctlItems:[
          {item:'サイト名',content:'セルフエステエンリケHP'},
          {item:'販売事業者名（会社名）',content:'株式会社エンリケ空間'},
          // {item:'運営責任者',content:'田中 勇多'},
          {item:'所在地',content:'〒104-0061 \n東京都中央区銀座8-12-3SRビル７・８F'},
          {item:'お問い合わせ',content:`当ホームページ記載のメールアドレスからお問い合わせください。`},
          {item:'販売価格',content:'予約手続きの際に画面に表示されます。消費税は内税として表示しております。'},
          {item:'販売価格以外でお客様に発生する金銭',content:'当HPのページの閲覧、コンテンツ購入、ソフトウェアのダウンロード等に必要となるインターネット接続料金、通信料金はお客様のご負担となります。'},
          {item:'お支払い方法',content:'クレカ、現金'},
          {item:'支払い時期',content:'サービス予約時'},
          {item:'商品購入方法',content:'初回購入時：もしくは本ホームページより店舗に直接連絡し、店舗にてご希望の決済方法でお支払いください。 二回目以降：会員ページの購入ページよりご購入ください。'},
          {item:'商品の引渡し時期',content:'予約日に来店時'},
          {item:'利用が可能となる時期',content:'お支払い手続き完了後、ご利用頂けます'},
          {item:'動作環境',content:'Windows OS,Mac OSで動作確認済み'},
          {item:'返品・キャンセル',content:'お客様のご都合によるキャンセルはご予約前日までのキャンセルとさせて頂きます。'},
          {item:'返品・キャンセル方法',content:'LINEにて返金要請してください。お客様情報確認でき次第、7日以内にご購入代金を指定の口座へお振込み致します。'},
        ]
      }
  },
}
</script>

<style scoped>
  @import "../../css/style.css";
  .sctl-img-box{
    text-align: center;
    margin-bottom: 30px;
  }

  .sctl-img{
    width: 70vw;
    
    left: 0;
    right: 0;
    margin: auto;
  }

  .sctl-table-row{
    border-bottom: solid 1px gray;

  }

  /* テーブルの最後の行だけ下線を引かない */
  .sctl-table-row:nth-last-child(1){
    border-bottom: none;
  }

  .sctl-table-headline{
    color: var(--main-color);
    padding: 0.8em 0;
  }

  /* PC表示 */
  @media screen and (min-width:821px){
    .sctl-title{
      font-size: 2.5rem;
      letter-spacing: 0.2em;

      color: var(--main-color);
      text-align: center;

      margin:50px auto;
    }

    .sctl-table{
      color: black;
      font-size: 16px;
      letter-spacing: 0.2em;
      text-align: left;

      width: 60vw;

      left: 0;
      right: 0;
      margin: auto auto 150px auto;

    }

    .sctl-table-content{
      padding: 0.8em 0 0.8em 3em;
      line-height: 2em;
      white-space: pre-wrap;
    }
  }

  /* スマホ表示 */
  @media screen and (max-width:820px){
    .sctl-title{
      font-size: 5vw;
      letter-spacing: 0.2em;

      color: var(--main-color);
      text-align: center;

      margin:2em;
    }

    .sctl-table{
      color: black;
      font-size: 12px;
      letter-spacing: 0.2em;
      text-align: left;

      width: 90vw;

      left: 0;
      right: 0;
      margin: auto auto 20px auto;

    }

    .sctl-table-content{
      padding: 0.8em 0 0.8em 1em;
      line-height: 2em;
      white-space: pre-wrap;
    }
  }
</style>